import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useResponsive } from '@hooks/useResponsive'
import GridColumns from '@components/GridColumns'
import StudentBookCard from '@components/StudentBookCard'
import { BUTTON_TYPE, COLORS, DIVIDER_SIZE } from '@helpers/constants'
import Divider from '@components/Divider'
import Button from '@components/Button'
import { useExamsAllowed } from '@hooks/useExamsAllowed'
import StudentBookCardNew from '@components/StudentBookCardNew'

const StudentBookList = (props) => {
  const { items, rowLimit = false } = props
  const [showAll, setShowAll] = useState(!rowLimit)
  const { breakpoints } = useResponsive()
  const cols = (() => {
    if (breakpoints.mobile) return 1
    if (breakpoints.tablet) return 2
    if (breakpoints.wide) return 3
    return 4
  })()

  const examsAllowed = useExamsAllowed()

  return (
    <div className={'w-full'}>
      <GridColumns cols={cols}>
        {(rowLimit && !showAll ? items.slice(0, cols * 2) : items).map(
          (book) => {
            const key = `book-${book.id}-${book?.pivot?.id}`

            if (examsAllowed) {
              return <StudentBookCardNew key={key} book={book} />
            } else {
              return <StudentBookCard key={key} book={book} />
            }
          }
        )}
      </GridColumns>

      {!showAll && items.length > rowLimit * cols && (
        <>
          <Divider size={DIVIDER_SIZE.SMALL} />

          <div className={'flex justify-end'}>
            <Button
              handleClick={() => {
                setShowAll(true)
              }}
              type={BUTTON_TYPE.PRIMARY}
              textColor={COLORS.BLACK.TEXT}
              backgroundColor={COLORS.SECONDARY_GREEN.BACKGROUND}
              icon={'ChevronDown'}
              iconRight
            >
              Visa alla
            </Button>
          </div>
        </>
      )}
    </div>
  )
}

StudentBookList.propTypes = {
  items: PropTypes.array,
}

export default StudentBookList
